import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
    mode: '',
      nickName: '',
      userName: '',
      userImage: '',
      ifLogin: false,
      ifYg: false,
      likeweb: [],
      userSite: [],
      wxAppData: '',
      refresh: true,
      refresh2: true,
      cid: '',
      userApple: '',
      news: [],
      badge: 0
    },
  getters: {
      nickName: (state) => state.nickName,
      userName: (state) => state.userName,
      userImage: (state) => state.userImage,
      ifLogin: (state) => state.ifLogin,
      wxAppData: (state) => state.wxAppData,
      badge: (state) => state.badge,
      userApple: (state) => state.userApple,
      refresh: (state) => state.refresh,
      refresh2: (state) => state.refresh2,
      cid: (state) => state.cid,

    },
    mutations: {
        pcMode(state) {
            state.mode = 'pc'
        },
        mobileMode(state) {
            state.mode = 'mobile'
        },
        addlikeWeb(state, id) {
            state.likeweb.push(id)
        },
        deletelikeWeb(state, index) {
            var a = state.likeweb.indexOf(index)
            state.likeweb.splice(a, 1);
        },
        adduserSite(state, id) {
            state.userSite.push(id)
        },
        deleteuserSite(state, index) {
            var a = state.userSite.indexOf(index)
            state.userSite.splice(a, 1);
        },
        wxAppData(state, data) {
            state.wxAppData = data;
        },
        likeweb(state) {
            state.likeweb = []
        },
        userSite(state) {
            state.userSite = []
        },
        news(state) {
            state.news = []
        },
        badge(state, data) {
            state.badge = data;
        },
        userApple(state, data) {
            state.userApple = data;
        },
        refresh(state, data) {
            console.log('data', data)
            state.refresh = data;
        },
        refresh2(state, data) {
            console.log('data', data)
            state.refresh2 = data;
        },
        cid(state, status) {
            state.cid = status;
        },
    }

})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js